// extracted by mini-css-extract-plugin
module.exports = {"block":"Metrics_block__PhrY0","blockTitle":"Metrics_blockTitle__2sEdo","metricsContainer":"Metrics_metricsContainer__3usey"};